import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import WithRouter from 'custom/withRouter';
import { reportOnlineInstoreReportCrumb } from 'utils/breadcrumbInfo';
import { checkDateRange } from 'utils/helpers';
import LOOKUP from 'constants/lookup';
import { showError } from 'actions/CommonActions';
import { formInput, clearFormInput } from 'actions/FormActions';
import { getInstoreOnlineSales, getCsvReport } from 'actions/ReportsAction';
import { clearProductList } from 'actions/EntityActions';
// Basic Components
import Grid from 'screens/components/basic/Grid';
import Pagination from 'screens/components/basic/Pagination';
import KnowledgeBase from 'screens/components/basic/KnowledgeBaseIcon';
import PageHeader from 'screens/components/basic/PageHeader';
import CardSimple from 'screens/components/basic/CardSimple';

import Body from './Body';
import Header from './Header';

class OnlineInstore extends Component {

    constructor(props) {
        super(props);
        this.state = {
            showBody: false,
            activePage: 1,
            itemsPerPage: 20,
            totalRow: 0
        }
        this.showBody = this.showBody.bind(this)
    }

    componentWillMount() {
        this.cleanSearch();
        const date = new Date();
        this.props.formInput(new Date(date.getFullYear(), date.getMonth(), 1), `OnlineInstoreBeginDate`);
        this.props.formInput(date, `OnlineInstoreEndDate`);
    }

    componentWillUnmount() {
        this.props.clearProductList();
    }

    cleanSearch = () => {
        this.props.clearFormInput(`OnlineInstoreBeginDate`);
        this.props.clearFormInput(`OnlineInstoreEndDate`);
        this.props.clearFormInput(`OnlineInstoreBranchOption`);
        this.props.clearFormInput(`OnlineInstoreProductId`);
    }

    changePage = (e) => {
        this.setState(pState => {
            return {
                ...pState,
                activePage: e
            };
        }, this.getReport);
    }

    getReport = () => {
        let beginDate = this.props.beginDate ? moment(this.props.beginDate).format('MM-DD-YYYY') : moment().add('day').format('MM-DD-YYYY');
        let endDate = this.props.endDate ? moment(this.props.endDate).add(1, "days").format('MM-DD-YYYY') : moment().add('day').format('MM-DD-YYYY');
        let branch = this.props.branch || this.props.loggedBranch;
        let pageSize = this.state.itemsPerPage;
        let pageNumber = this.state.activePage;
        let productId = this.props.productId || 0;

        this.props.getInstoreOnlineSales({ beginDate, endDate, branch, productId, pageNumber, pageSize });
    }

    downloadReport = () => {
        let beginDate = this.props.beginDate ? moment(this.props.beginDate).format('MM-DD-YYYY') : moment().add('day').format('MM-DD-YYYY');
        let endDate = this.props.endDate ? moment(this.props.endDate).add(1, "days").format('MM-DD-YYYY') : moment().add('day').format('MM-DD-YYYY');
        let branch = this.props.branch || this.props.loggedBranch;
        let productId = this.props.productId || 0;
        if (checkDateRange(beginDate, endDate)) {
            this.props.showError(LOOKUP.report.common.dateRangeError);
        } else {
            this.props.getCsvReport(`reports/excel/onlineinstore?beginDate=${beginDate}&endDate=${endDate}&branch=${branch}&productId=${productId}`, "OnlineInstore");
        }
    }

    getProductOptions = () => {
        return (this.props.products || []).map(item => {
            return {
                text: item.name,
                value: item.id,
                categoryId: item.categoryId
            };
        });
    }

    showBody() {
        if (checkDateRange(this.props.beginDate, this.props.endDate)) {
            this.props.showError(LOOKUP.report.common.dateRangeError);
        } else {
            this.filter();
            this.setState({ showBody: true });
        }
    }

    filter = () => {
        this.setState(pState => {
            return {
                ...pState,
                activePage: 1
            };
        }, this.getReport);
    }

    redirectToReport = () => {
        this.props.navigate("/report");
    }

    componentWillReceiveProps = (newProps) => {
        if (newProps !== this.props) {
            if (this.state.showBody) {
                const totalRow = newProps.instoreOnlineSales && newProps.instoreOnlineSales.list.length > 0 ? newProps.instoreOnlineSales.total : 0;
                this.setState({ totalRow: totalRow })
            }
        }
    }

    render() {
        return (
            <Grid headerContent={reportOnlineInstoreReportCrumb}>
                <PageHeader 
                    title={LOOKUP.report.onlineInstore.text}
                    description={LOOKUP.report.onlineInstore.description}
                    icon={<KnowledgeBase />}
                />
                {(!this.props.branchOptions || this.props.branchOptions.length == 0) &&
                    <div style={{ color: `#FF4C5B` }} className="row m-0 pa-2"><h5>No branches available to query</h5></div>}

                <Header
                    branchOptions={this.props.branchOptions}
                    download={this.downloadReport}
                    showBody={this.showBody}
                    products={this.getProductOptions()}
                    loggedBranch={this.props.loggedBranch.toString()}
                    disabled={this.props.branchOptions && this.props.branchOptions.length == 0}
                />
                {
                    this.state.showBody && this.props.instoreOnlineSales &&
                    <CardSimple>
                        <Body
                            instoreOnlineSales={this.props.instoreOnlineSales.list}
                            beginDate={this.props.beginDate}
                            endDate={this.props.endDate}
                        />
                        <Pagination
                            length={this.state.totalRow}
                            itemsPerPage={this.state.itemsPerPage}
                            activePage={this.state.activePage}
                            onPageChange={this.changePage}
                        />
                    </CardSimple>
                }
            </Grid>
        );
    }
}

const mapStateToProps = state => {
    let branches = state.common.userBranches || [];
    let branchOptions = [];
    branches.map((item) => {
        branchOptions.push({
            text: item.name, value: item.id.toString()
        });
    })

    return {
        branchOptions: branchOptions,
        instoreOnlineSales: state.reports.instoreOnlineSales,
        loggedBranch: state.common.branchId,
        beginDate: state.form.OnlineInstoreBeginDate,
        endDate: state.form.OnlineInstoreEndDate,
        branch: state.form.OnlineInstoreBranchOption,
        productId: state.form.OnlineInstoreProductId,
        products: state.entity.productList,
        store: state.common.store
    };
};

const mapDispatchToProps = dispatch => {
    return {
        getInstoreOnlineSales: (model) => dispatch(getInstoreOnlineSales(model)),
        clearFormInput: (name) => dispatch(clearFormInput(name)),
        formInput: (value, name) => dispatch(formInput(value, name)),
        showError: (message) => dispatch(showError(message)),
        clearProductList: () => dispatch(clearProductList()),
        getCsvReport: (url, name) => dispatch(getCsvReport(url, name))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(WithRouter(OnlineInstore));
